import { Module } from "vuex";
import { IRootState } from "@/store/types";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { IANumberAssignment } from "@/models/anumberassignments";
import { IANumberGroup } from "@/models/anumbergroup";
import { IANumber } from "@/models/anumber";

export interface IANumbersState {
    aNumberAssignmentsList: IANumber[] | null;
    aNumberGroupsList: IANumberGroup[] | null;
    selectedANumberAssignment: IANumberAssignment | null;
    selectedANumberGroup: IANumberGroup | null;
    aNumberAssignmentsError: any;
    aNumberGroupsError: any;
}

export const getDefaultANumbersState = (): IANumbersState => {
    return {
        aNumberAssignmentsList: [],
        aNumberGroupsList: [],
        selectedANumberAssignment: null,
        selectedANumberGroup: null,
        aNumberAssignmentsError: null,
        aNumberGroupsError: null,
    };
};

const state = getDefaultANumbersState();

const namespaced: boolean = true;

export const aNumbers: Module<IANumbersState, IRootState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
